const skills = {
  // ── 1: Front-End ──────────────────────────────────────────────
  1: [
    { title: 'JavaScript',  level: 5 },
    { title: 'TypeScript',  level: 4 },
    { title: 'React / Next.js', level: 5 },
    { title: 'HTML / CSS',  level: 5 },
    { title: 'SASS',        level: 2 },
    { title: 'WordPress',   level: 4 },
  ],

  // ── 2: Back-End ───────────────────────────────────────────────
  2: [
    { title: 'Python / FastAPI', level: 4 },
    { title: 'Java / Spring',    level: 4 },
    { title: 'Node / Express',   level: 4 },
    { title: 'Go',               level: 3 },
    { title: 'SQL / PostgreSQL', level: 4 },
    { title: 'MongoDB',          level: 4 },
  ],

  // ── 3: Cloud & DevOps ─────────────────────────────────────────
  3: [
    { title: 'AWS',              level: 5 },
    { title: 'Docker',           level: 4 },
    { title: 'Kubernetes',       level: 3 },
    { title: 'Terraform',        level: 3 },
    { title: 'GitHub Actions',   level: 4 },
    { title: 'Prometheus / ELK', level: 3 },
  ],

  // ── 4: AI & Agents ────────────────────────────────────────────
  4: [
    { title: 'LangGraph',        level: 4 },
    { title: 'LlamaIndex',       level: 4 },
    { title: 'RAG Pipelines',    level: 4 },
    { title: 'Vector DBs',       level: 3 },
    { title: 'PyTorch',          level: 3 },
    { title: 'GPT-4o / LLMs',   level: 5 },
  ],
};

export default skills;
